import React, { useEffect, useState } from "react";
import { useFeedbackGrid } from "Hooks/target/overview/useFeedbackGrid";
import { Grid } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { checkArrayLength } from "src/utils";

const GridView = props => {
  const { feedbackListingColumns, feedbackFetchColumn } = useFeedbackGrid();
  const [columnsState] = useState(feedbackListingColumns);

  const [result, setResult] = useState([]);
  const [dataState, setDataState] = useState({});

  const createDataState = (data, dataState) => {
    setResult(process(data.slice(0), dataState));
    setDataState(dataState);
  };

  useEffect(() => {
    if (checkArrayLength(props?.data)) {
      createDataState(props.data, dataState);
    }
  }, [props.data]);

  return (
    <Grid
      {...dataState}
      data={result}
      pageable={true}
      pageSize={5}
      sortable={false}
      // style={{
      //   height: "290px"
      // }}
    >
      {columnsState.map(column => column.show && feedbackFetchColumn(column))}
    </Grid>
  );
};

export default GridView;
